import Store from '@ember-data/store';
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import { dasherize } from '@ember/string';
import JournalInfo from 'donor-elf-web/lib/models/journal-info';
import JournalReportModel from 'donor-elf-web/models/all-funds/journal-report';

type IntervalTimespan = 'week' | 'month' | 'day';

export interface JournalReportRouteModel {
  journalInfo: JournalInfo;
  journalReport: JournalReportModel;
  intervalTimespan: IntervalTimespan;
}

export default class JournalReportRoute extends Route {
  @service declare fundsService: any;
  @service declare journalService: any;
  @service declare navbarSettings: any;
  @service declare router: RouterService;
  @service declare store: Store;
  @service declare taskService: any;

  queryParams = {
    interval: {
      refreshModel: true,
    },
  };

  beforeModel() {
    this.navbarSettings.title = 'Journal Report';
  }

  async model(params: {
    interval?: IntervalTimespan;
  }): Promise<JournalReportRouteModel> {
    await this.fundsService.confirmValidFundToken();
    await this.taskService.load();
    await this.journalService.load();

    let intervalTimespan: IntervalTimespan = params.interval || 'week';
    let journalId = (this.paramsFor('funds.fund.journals.journal') as any)
      .journalId;
    let journalInfo = this.journalService.journalInfoById(journalId);
    this.navbarSettings.title = `${journalInfo.journal.label} Journal Report`;
    let journalReport = (
      await this.store.query('all-funds/journal-report', {
        filter: { journal_id: journalId, interval_timespan: intervalTimespan },
      })
    ).slice()[0];
    return {
      journalInfo,
      journalReport,
      intervalTimespan,
    };
  }

  redirect(model: JournalReportRouteModel) {
    this.router.transitionTo(
      `funds.fund.journals.journal.report.${dasherize(model.journalReport.name)}`,
    );
  }
}
